import '~/js/modules/section-hero';
import 'slick-carousel';

const rates = window.beaches_app.page.rates;
const $averageRate = $('#averageRate');
const $childRate = $('#childRate');
const $carousel = $('.js-carousel');
let childRateLowest;
let averageRateLowest;

// Initialization carousel
$carousel.slick({
  prevArrow: '<button class="rooms-prev icon-link-arrow-beaches"></button>',
  nextArrow: '<button class="rooms-next icon-link-arrow-beaches"></button>',
});

$.each(rates, (index, value) => {
  if(!childRateLowest || value[0].childRate < childRateLowest) {
    childRateLowest = value[0].childRate;
  }
  if(!averageRateLowest || value[0].averageRate < averageRateLowest) {
    averageRateLowest = value[0].averageRate;
  }
});

$childRate.html('<span>$</span>' + childRateLowest);
$averageRate.html('<span>$</span>' + averageRateLowest);

//------- View Resorts slider
//document.addEventListener(onclick, scrollContent);
//const scrollContent = (tabId) => {
  //$([document.documentElement, document.body]).animate(
   // {
   //   scrollTop: $(".slider").offset().top - 233
   // }, {
    //  duration: 800,
     // queue: false
    //});
//};

//------ Carousel
const $resortCarousel = $('#inc-carousel');
const $control = $('#inc-carousel-control');

const $counter = $('.carousel-counter');

$resortCarousel.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
  // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  const i = (currentSlide ? currentSlide : 0) + 1;

  $counter.text(i + '/' + slick.slideCount);
});

$resortCarousel.slick({
  appendArrows: $control,
  mobileFirst: true,
  variableWidth: true,
  centerMode: true,
  arrows: true,
  prevArrow: '<button class="icon-button-prev arrow-prev"></button>',
  nextArrow: '<button class="icon-button-next arrow-next"></button>',
});
